import { useMediaQuery } from '@mui/material';

import { CloseIcon } from '../../../../icons/CloseIcon';
import { GroupedOptions } from '../../DestinationSearch.types';
import {
  Group,
  Option,
  StyledLabel,
  Suggestion,
} from './SuggestionsList.styles';

export const SuggestionsList = ({
  groupedItems,
  onRemoveItem,
}: {
  groupedItems: GroupedOptions;
  onRemoveItem?: (label: string) => void;
}) => {
  const isDesktop = useMediaQuery('(min-width: 900px)');

  return (
    <div key={groupedItems.label}>
      <Group mobileSize="md" bold elementType="span">
        {groupedItems.icon && <groupedItems.icon />}

        {groupedItems.label}
      </Group>

      {groupedItems.items
        .slice(0, isDesktop ? undefined : 3)
        .map((item, index) => (
          <Option
            key={`${item.categoryType}-${item.label}-${item.slug}-${item.polygonId}`}
            value={{ ...item, indexOfType: index }}
          >
            <Suggestion>
              <StyledLabel mobileSize="md" elementType="span">
                {item.label}
              </StyledLabel>
              {onRemoveItem && (
                <CloseIcon
                  onMouseDown={(event) => {
                    event.preventDefault();
                    onRemoveItem(item.label);
                  }}
                />
              )}
            </Suggestion>
          </Option>
        ))}
    </div>
  );
};
